var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.767 44.661a16.047 16.047 0 0 1-2.809 8.988 16.407 16.407 0 0 1-7.4 5.94 16.682 16.682 0 0 1-9.5.894 16.53 16.53 0 0 1-8.407-4.454 16.14 16.14 0 0 1-4.483-8.303c-.629-3.143-.299-6.4.949-9.358a16.268 16.268 0 0 1 6.061-7.265 16.63 16.63 0 0 1 9.134-2.728 16.619 16.619 0 0 1 11.65 4.786 16.133 16.133 0 0 1 4.805 11.5ZM66.83 44.66c0 8.504-3.656 15.35-8.19 15.35-4.534 0-8.19-6.846-8.19-15.35 0-8.503 3.656-15.348 8.19-15.348 4.461 0 8.19 6.918 8.19 15.349ZM74.144 44.662c0 7.566-1.317 13.763-2.926 13.763-1.609 0-2.925-6.197-2.925-13.763 0-7.567 1.316-13.764 2.925-13.764 1.682 0 2.925 6.197 2.925 13.764Z",
    fill: "var(--a, #000)"
  })));
};

export default SvgMedium;